<template>
  <div class="character">
    <div class="shadow"></div>
    <div class="sprite"></div>
  </div>
</template>

<script>
export default {
  name: 'Character'
}
</script>

<style lang="sass" scoped>
.character
  width: 16px
  height: 24px
  position: relative
  .sprite
    width: 100%
    height: 100%
    border: solid 1px #9d9d9d
    z-index: 1
    position: relative
    background: #fff
  .shadow
    width: 32px
    height: 6px
    z-index: 0
    position: absolute
    left: -8px
    bottom: -2px
    background: #cbcbcb
    border-radius: 100%
</style>
